import styled from 'styled-components';
import { LiveQa } from './liveQa';

export default function QaThread({ item, showAnswerLabel = true }: { item: LiveQa; showAnswerLabel?: boolean }) {
  return <Thread aria-label={`${item.nickname} 질문과 관리자 답변`}>
    <Question><Mark>Q</Mark><p>{item.question}</p></Question>
    <Answer $showLabel={showAnswerLabel}><Mark>A</Mark><div>{showAnswerLabel && <strong>관리자 답변</strong>}<p>{item.answer}</p></div></Answer>
  </Thread>;
}
const Thread = styled.div`font-family: var(--font-family-base, var(--font-Pretendard-Regular)); font-size: var(--text-body, 15px); line-height: 1.6; color: var(--user-text);`;
const Question = styled.div`display: flex; align-items: flex-start; gap: var(--space-2, 8px); p { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; font-weight: 600; }`;
const Mark = styled.span`flex: none; color: var(--user-accent); font-weight: 700;`;
const Answer = styled(Question)<{ $showLabel: boolean }>`
  margin-top: var(--space-3, 12px); padding: var(--space-3, 12px); border-radius: var(--radius-md, 12px); background: var(--user-surface-raised);
  strong { font-size: var(--text-caption, 13px); color: var(--user-text-muted); }
  p { margin-top: ${({ $showLabel }) => $showLabel ? 'var(--space-1, 4px)' : '0'}; font-weight: 400; }
`;
